import ItemModel from "models/item";
import { IScope } from "reducers/scope";

export type TGTagCommand = "event" | "config" | "set" | "get";

export enum GTagGroup {
    Default = "default",
    Brand = "brand",
    B2B = "b2b",
}

export interface IGTagConfig {
    id: string;
    properties: {
        groups?: GTagGroup[];
        debug_mode?: boolean;
        send_page_view?: boolean;
    };
}

export interface GoogleAnalyticsEvent {
    event: string;
    properties: object;
    send_to: GTagGroup | GTagGroup[] | GTagGroup.Default;
}

export interface GoogleAnalyticsEventData {
    event?: string;
    send_to: GTagGroup | GTagGroup[] | GTagGroup.Default;
}

export interface GooglePageViewInput extends GoogleAnalyticsEventData {
    page_title: string;
    page_location: string;
}

export type GoogleItem = {
    item_id: string;
    item_name: string;
    affiliation?: string;
    coupon?: string;
    discount?: number;
    item_brand?: string;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
    item_list_id?: string;
    item_list_name?: string;
    location_id?: string;
    price?: number;
    quantity?: number;
};

export interface GoogleItemInput extends GoogleAnalyticsEventData {
    currency: string;
    value: number;
    items: GoogleItem[];
}

export interface GoogleCheckoutInput extends GoogleItemInput {
    coupon?: string;
    shipping_tier?: string;
    shipping?: string;
    payment_type?: string;
    tax?: number;
    transaction_id?: string;
}

export interface GoogleListInput extends GoogleAnalyticsEventData {
    items: GoogleItem[];
    item_list_name: string;
    item_list_id: string;
}

export enum RREventType {
    SUBMITTED_RR_ORDER = "submitted-RR-order",
    SAVED_RR_DRAFT_ORDER = "saved-RR-draft-order",
    SUBMITTED_RR_EZ_ORDER = "submitted-RR-ez-order",
}

export interface Cart {
    items: GoogleItem[];
    currency: string;
    value: number;
}

export interface FormatItemsWithBulkInput {
    items: {
        single: typeof ItemModel;
        bulk: any;
    };
    props: {
        scope: IScope;
        entities: any;
    };
    list: {
        affiliation?: string;
        item_list_id?: string;
        item_list_name?: string;
    };
}
